/* tslint:disable */
/* eslint-disable */
/**
 * back-office-service
 * Back Office Service
 *
 * The version of the OpenAPI document: 0.27.85
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * A draw game represents a game that has regularly scheduled drawing to determine winners. A common example would be
 * things like Mega Millions or Powerball. Draw games have drawings on a fixed schedule that happen at certain times
 * every week. Sometimes they also have progressive jackpot values that get bigger every time someone doesn't win the
 * jackpot in a particular drawing.
 * 
 * Some types of draw games, most notable Keno variations, that are drawn on a rapid interval rather than a fixed
 * schedule are instead represented by the RapidGame model.
 * @export
 * @interface DrawGame
 */
export interface DrawGame {
    /**
     * Maximum valid number that can be drawn in this game's primary winning numbers.
     * Used by the hot/cold numbers API to determine the full range of possible values.
     * @type {number}
     * @memberof DrawGame
     * @deprecated
     */
    maxDrawValue?: number | null;
    /**
     * Minimum valid number that can be drawn in this game's primary winning numbers.
     * Used by the hot/cold numbers API to determine the full range of possible values.
     * @type {number}
     * @memberof DrawGame
     * @deprecated
     */
    minDrawValue?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof DrawGame
     */
    hasProgressiveJackpots: boolean;
    /**
     * Optional logo image URL for the game
     * @type {string}
     * @memberof DrawGame
     */
    logoUrl?: string | null;
    /**
     * Date the game stopped being active. This will be null for a currently active game.
     * @type {Date}
     * @memberof DrawGame
     */
    activeTo?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof DrawGame
     */
    activeFrom: Date;
    /**
     * Optional external ID of the game from another system
     * @type {string}
     * @memberof DrawGame
     */
    gameId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DrawGame
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof DrawGame
     */
    customerId: string;
    /**
     * 
     * @type {string}
     * @memberof DrawGame
     */
    id: string;
}

/**
 * Check if a given object implements the DrawGame interface.
 */
export function instanceOfDrawGame(value: object): value is DrawGame {
    if (!('hasProgressiveJackpots' in value) || value['hasProgressiveJackpots'] === undefined) return false;
    if (!('activeFrom' in value) || value['activeFrom'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('customerId' in value) || value['customerId'] === undefined) return false;
    if (!('id' in value) || value['id'] === undefined) return false;
    return true;
}

export function DrawGameFromJSON(json: any): DrawGame {
    return DrawGameFromJSONTyped(json, false);
}

export function DrawGameFromJSONTyped(json: any, ignoreDiscriminator: boolean): DrawGame {
    if (json == null) {
        return json;
    }
    return {
        
        'maxDrawValue': json['maxDrawValue'] == null ? undefined : json['maxDrawValue'],
        'minDrawValue': json['minDrawValue'] == null ? undefined : json['minDrawValue'],
        'hasProgressiveJackpots': json['hasProgressiveJackpots'],
        'logoUrl': json['logoUrl'] == null ? undefined : json['logoUrl'],
        'activeTo': json['activeTo'] == null ? undefined : (new Date(json['activeTo'])),
        'activeFrom': (new Date(json['activeFrom'])),
        'gameId': json['gameId'] == null ? undefined : json['gameId'],
        'name': json['name'],
        'customerId': json['customerId'],
        'id': json['id'],
    };
}

export function DrawGameToJSON(value?: DrawGame | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'maxDrawValue': value['maxDrawValue'],
        'minDrawValue': value['minDrawValue'],
        'hasProgressiveJackpots': value['hasProgressiveJackpots'],
        'logoUrl': value['logoUrl'],
        'activeTo': value['activeTo'] == null ? undefined : ((value['activeTo'] as any).toISOString()),
        'activeFrom': ((value['activeFrom']).toISOString()),
        'gameId': value['gameId'],
        'name': value['name'],
        'customerId': value['customerId'],
        'id': value['id'],
    };
}

